import React from 'react';
import destionation from '@src/assets/destination.svg';
import { ZoneMapProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { selectFreehandShapeUponCreation, selectZoneMapLocationUponCreation, setSelectedZone } from '@src/features/zones/redux';
import { getGeocode } from 'use-places-autocomplete';
import { setMapLocation } from '@src/core/controllers';
import { useGoogleMap } from '@react-google-maps/api';
import { useLocation } from 'react-router-dom';
import FreehandShapeDrawer from '@src/features/zones/components/free-hand-shape-drawer';
import ArcZonePolygon from '@src/core/ui/arc-zone-polygon';
import { ZoneShapeType } from '@src/core/features';
import ArcZoneMarker from '@src/core/ui/arc-zone-marker';

const ZonesMap: React.FC<ZoneMapProps> = (props) => {
  const { zones } = props;

  const dispatch = useDispatch();
  const createdZoneUponCreation = useSelector(selectZoneMapLocationUponCreation);
  const freehandShapeUponCreation = useSelector(selectFreehandShapeUponCreation);

  const location = useLocation();
  const filteredActiveZones = zones.filter((zone) => zone.isActive);

  const map = useGoogleMap();

  const onDragDrop = async (e: google.maps.MapMouseEvent) => {
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();

    if (!lat || !lng) return;

    const payload = { location: { lat, lng } };
    const addresses = await getGeocode(payload);
    const [{ formatted_address }] = addresses;
    
    dispatch(setMapLocation({
      latitude: lat,
      longitude: lng,
      address: formatted_address
    }));
    
  };
  

  return (
    <>
      {filteredActiveZones.map((zone) => {
        if (zone.id === Number(createdZoneUponCreation?.id)) return null;
        if(zone.id === Number(freehandShapeUponCreation?.id)) return null;

        return zone.shape === ZoneShapeType.CIRCLE ? (
          <ArcZoneMarker
            key={zone.id}
            position={{
              lat: Number(zone.centerLatitude),
              lng: Number(zone.centerLongitude),
            }}
            radius={zone.radiusMeters}
            icon={{
              url: destionation,
              scaledSize: new window.google.maps.Size(100, 50),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(17, 44),
            }}
            label={zone.name}
            type={zone.zoneType}
            showMarkerIcon={true}
            onClick={() => { dispatch(setSelectedZone(zone));}}
          />
        ) : (
          <ArcZonePolygon
            key={zone.id}
            path={zone.polygonCoordinates as google.maps.LatLngLiteral[]}
            label={zone.name}
            type={zone.zoneType}
            showMarkerIcon={true}
            onClick={() => { dispatch(setSelectedZone(zone));}}
          />
        );
      })}

  
      {createdZoneUponCreation && (
        <ArcZoneMarker
          key={createdZoneUponCreation.id}
          position={{
            lat: createdZoneUponCreation.latitude,
            lng: createdZoneUponCreation.longitude,
          }}
          radius={createdZoneUponCreation.radius}
          label={createdZoneUponCreation.zoneName}
          type={createdZoneUponCreation.type}
          draggable={true}
          onDragEnd={onDragDrop}
          showMarkerIcon={true}
        />
      )}

      <FreehandShapeDrawer
        active={location.search.includes("stage=2")}
        onComplete={(coords) => console.log("Created zone:", coords)}
        map={map}
      />

      {freehandShapeUponCreation && (
        <ArcZonePolygon
          showMarkerIcon={true}
          path={freehandShapeUponCreation.polygonCoordinates}
          label={freehandShapeUponCreation.name}
          type={freehandShapeUponCreation.type}
        />
      )}
    </>
  );
};

export default ZonesMap;
